import { render, staticRenderFns } from "./JournalReportNew.vue?vue&type=template&id=423c5d08&"
import script from "./JournalReportNew.vue?vue&type=script&lang=ts&"
export * from "./JournalReportNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports